import { useEffect } from 'react';
import { useAnimatedReaction } from 'react-native-reanimated';
import { scheduleOnRN } from 'react-native-worklets';
import { useParkingStore } from 'stores/parkingStore';
import { useUiStore } from 'stores/uiStore';
import { isItemParking } from 'utils/parkUtils';
import useCustomBottomSheet from './useCustomBottomSheet';
import useOngoingMultipleSession from './useOngoingMultipleSession';

const useOngoingSheetState = (isMultiple: boolean) => {
  const { animatedIndex, expand, collapse } = useCustomBottomSheet();
  const selectedOngoing = useParkingStore(
    (state) => state.selectedOngoingSession
  );
  const { parkAndChargeData } = useOngoingMultipleSession();

  useEffect(() => {
    if (parkAndChargeData.length === 0) {
      useParkingStore.getState().setSelectedOngoingSession(undefined);
    }
  }, [parkAndChargeData]);

  const handleExpandOngoingSessionOnStart = () => {
    const parkingSessions = parkAndChargeData.filter(isItemParking);
    useUiStore.getState().setExpandOngoingSheet(false);
    if (parkingSessions.length > 1) {
      useUiStore.getState().setSheetModal('showOngoingMultipleSessions');
      return useParkingStore.getState().setSelectedOngoingSession(undefined);
    }
    useParkingStore
      .getState()
      .setSelectedSessionIdFromMultiple(
        parkingSessions.find(Boolean)?.sessionId ?? null
      );
    return useParkingStore
      .getState()
      .setSelectedOngoingSession(
        parkingSessions.length === 1 ? 'PARKING' : 'CHARGING'
      );
  };

  const setOngoingSheet = (val: number) => {
    if (val === 0) {
      if (
        useUiStore.getState().expandOngoingSheet &&
        parkAndChargeData.length > 0
      ) {
        return handleExpandOngoingSessionOnStart();
      }
      return useParkingStore.getState().setSelectedOngoingSession(undefined);
    }
    if (val === 1 && parkAndChargeData?.length === 1) {
      return useParkingStore
        .getState()
        .setSelectedOngoingSession(
          isItemParking(parkAndChargeData[0]) ? 'PARKING' : 'CHARGING'
        );
    }
  };

  useAnimatedReaction(
    () => {
      return Math.round(animatedIndex.value);
    },
    (currentValue, previousValue) => {
      if (currentValue !== previousValue) {
        scheduleOnRN(setOngoingSheet, currentValue);
      }
    }
  );

  // Snappoints changing (OngoingSessionsSheet) don't always cause the sheet to collapse, so this is a fallback
  useEffect(() => {
    if (isMultiple) {
      setTimeout(() => {
        collapse();
      }, 250);
    }
  }, [collapse, isMultiple]);

  useEffect(() => {
    if (selectedOngoing) {
      setTimeout(() => {
        expand();
      }, 250);
    } else if (selectedOngoing === undefined && animatedIndex.value === 1) {
      collapse();
    }
  }, [selectedOngoing, expand, animatedIndex.value, collapse]);
};

export default useOngoingSheetState;
